import { ReloadOutlined } from "@ant-design/icons";
import { useContext, useState } from "react";
import { DataContext } from "../../lib/contexts";
import { clearStatistics } from "../../lib/statisticsHandler";
import { ConfirmModal } from "../elements/confirmModal";
import { MButton } from "../elements/mbutton";
import { SettingsContentContainer } from "./settingsContentContainer";

export function StatisticsContent() {
  const [showClearConfirm, setShowClearConfirm] = useState(false);

  const { refreshItems } = useContext(DataContext);

  return (
    <SettingsContentContainer>
      <p
        style={{
          margin: "12px 0 20px",
          color: "#6b7280",
          fontSize: 14,
          lineHeight: 1.5,
          textAlign: "center",
        }}
      >
        Statistikken gemmer, hvor ofte du tilføjer varer til indkøbslisten på
        denne enhed. Den bruges til at prioritere vareforslag og søgeresultater.
      </p>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <MButton
          type="danger"
          icon={<ReloadOutlined />}
          onClick={() => setShowClearConfirm(true)}
        >
          Nulstil statistik
        </MButton>
      </div>
      <ConfirmModal
        visible={showClearConfirm}
        title="Nulstil statistik"
        message="Er du sikker på, at du vil nulstille din statistik?"
        onCancel={() => setShowClearConfirm(false)}
        confirmButton={
          <MButton
            type="danger"
            icon={<ReloadOutlined />}
            onClick={async () => {
              await clearStatistics();
              await refreshItems();
              setShowClearConfirm(false);
            }}
          >
            Nulstil statistik
          </MButton>
        }
      />
    </SettingsContentContainer>
  );
}
